import { SharedIcon, SharedIconProps } from 'components/SharedIcon/SharedIcon';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import RoleTag from './RoleTag';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { MaterialSymbols } from 'material-design-icons-literal-types';

type HeaderLeftProps = {
  iconName: MaterialSymbols;
  iconColor: SharedIconProps['color'];
  title: string;
  subtitle: string;
  titleInfoTooltip?: string;
};

const HeaderLeft: React.FC<HeaderLeftProps> = ({
  iconName,
  iconColor,
  title,
  subtitle,
  titleInfoTooltip,
}) => {
  return (
    <div className="d-flex flex-column align-items-start">
      <h3 className="mb-0 mt-0 d-flex align-items-center flex-wrap gap-1">
        <SharedIcon iconName={iconName} classes="me-2" color={iconColor} />
        <span>{title}</span>
        {titleInfoTooltip ? (
          <OverlayTrigger
            placement="top"
            overlay={(props) => (
              <Tooltip id="ics-widget-header-info-tooltip" {...props}>
                {titleInfoTooltip}
              </Tooltip>
            )}
          >
            <span
              className="d-inline-flex align-items-center text-weak"
              role="button"
              tabIndex={0}
              aria-label={titleInfoTooltip}
            >
              <SharedIcon iconName="info" size="sm" color="primary" />
            </span>
          </OverlayTrigger>
        ) : null}
      </h3>
      <div className="ps-4 text-weak">{subtitle}</div>
    </div>
  );
};

type HeaderRightProps = {
  icsRoles: string[];
  handleExport?: () => void;
  exportText?: string;
  disabledExport?: boolean;
};

const HeaderRight: React.FC<HeaderRightProps> = ({
  icsRoles,
  handleExport,
  exportText,
  disabledExport,
}) => {
  return (
    <div className="d-flex gap-2 align-items-center">
      <RoleTag icsRoles={icsRoles} />
      {handleExport && (
        <StylishNewButton
          className="button button--secondary gap-1"
          onClick={(e) => {
            e.stopPropagation();
            handleExport();
          }}
          disabled={disabledExport}
        >
          <SharedIcon iconName="visibility" size="sm" /> {exportText}
        </StylishNewButton>
      )}
    </div>
  );
};

export const ICSWidget = {
  HeaderLeft,
  HeaderRight,
};

export default ICSWidget;
